import { render, staticRenderFns } from "./ViewOpportunity.vue?vue&type=template&id=413515e5&scoped=true&"
import script from "./ViewOpportunity.vue?vue&type=script&lang=js&"
export * from "./ViewOpportunity.vue?vue&type=script&lang=js&"
import style0 from "./ViewOpportunity.vue?vue&type=style&index=0&id=413515e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413515e5",
  null
  
)

export default component.exports